import Appsignal from '@appsignal/javascript';
import {plugin as breadcrumbs} from '@appsignal/plugin-breadcrumbs-network';
import {plugin as pathDecorator} from '@appsignal/plugin-path-decorator';
import {plugin as windowEvents} from '@appsignal/plugin-window-events';

export const appsignal = new Appsignal({
  key: window.app_signal_api_key,
  revision: process.env.VERSION,
});
appsignal.use(windowEvents()); // should log all uncaught errors in AppSignal
appsignal.use(pathDecorator());
appsignal.use(breadcrumbs());

document.body.addEventListener('pointermove', () => {
  document.body.classList.add('using-mouse');
});

document.body.addEventListener('keydown', () => {
  document.body.classList.remove('using-mouse');
});
